import { render } from "./ProcedurePatientQueueModal.vue?vue&type=template&id=3acebddf"
import script from "./ProcedurePatientQueueModal.vue?vue&type=script&lang=js"
export * from "./ProcedurePatientQueueModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__